<template>
  <div>
    <the-header />
    <div class="animationFix">
      <slot />
    </div>
    <the-footer />
  </div>
</template>
<script>
import TheHeader from '../components/Common/TheHeader';
import TheFooter from '../components/Common/TheFooter';
export default {
  components: {
    TheHeader,
    TheFooter
  },
  created(){
    this.$axios.get('settings')
      .then(res => {
        let {sources, statuses} = res.data
        this.$store.dispatch('setStatusesMaster', statuses)
      })
      .catch(err => console.log(err.response))
      this.$axios.get('leads/settings')
      .then(res => {
        let {dead_ids, dead_reasons, cities} = res.data
        this.$store.dispatch('setDeadStatusIds', dead_ids)
        this.$store.dispatch('setDeadReasons', dead_reasons)
        this.$store.dispatch('setCity', cities)
      })
      .catch(err => console.log(err.response))
  }
}
</script>